import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import selectn from "selectn";

import StoryHeader from "../StoryHeader";
import StoryContent from "../StoryContent";
import StoryFooter from "../StoryFooter";
import ErrorBoundary from "components/Library/ErrorBoundary";

import styles from "./StoryCard.css";
import { FACTS_MATTER_TEMPLATE } from "../../../config/constants";

class StoryCard extends Component {

  render() {
    const { story, hideHeader, hideFooter, header, storyType, permalinkId, index } = this.props;
    if (!story) return null;

    return (
      <ErrorBoundary>
        <div
          id={story.id}
          className={classNames(
            "story-card",
            styles.root,
            this.props.className,
            story.slideIn ? styles.slideIn : {},
            (story.template === FACTS_MATTER_TEMPLATE && styles.factsMatter) ||
            (story.is_featured && !selectn("rubric.name", story) && styles.featured),
          )}>
          <div className={classNames("permalink", styles.hide)}>{story.permalink}</div>
          {!hideHeader && (header || <StoryHeader story={story}/>)}
          <StoryContent story={story} storyType={storyType} permalinkId={permalinkId} index={index} />
          {!hideFooter && <StoryFooter story={story}/>}
        </div>
      </ErrorBoundary>
    );
  }
}

StoryCard.propTypes = {
  story: PropTypes.object,
  storyType: PropTypes.oneOf(["newsletter"]),
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  header: PropTypes.element,
  className: PropTypes.string,
  permalinkId: PropTypes.string,
};

export default StoryCard;



// WEBPACK FOOTER //
// ./src/components/Library/StoryCard/StoryCard.js